import { Sheet, SheetContent } from "@workspace/web-ui/components/sheet";
import { TodoAppointmentDetails } from "./todo-appointment-details"
import { TodoMedicationRefillDetails } from "./todo-refill-details"
import { FormattedEncounter } from "~/features/dashboard/pages/encounters/types"
import { TodoConsultationDetails } from "./todo-consultation-details"
import { cn } from "@workspace/web-ui/lib/utils"
import { useIsMobile } from "~/hooks/use-mobile";

type TodoDetailsContentProps = {
    encounter: FormattedEncounter
    className?: string
}

// This component displays the details without the sheet
const TodoDetailsContent = ({ encounter, className }: TodoDetailsContentProps) => {
    return (
        <div className={cn(className)}>
            {encounter.type === "appointment" && <TodoAppointmentDetails encounter={encounter} />}
            {encounter.type === "refill" && <TodoMedicationRefillDetails encounter={encounter} />}
            {encounter.type === "consultation" && <TodoConsultationDetails encounter={encounter} />}
        </div>
    )
}

type TodoDetailsProps = {
    open: boolean;
    onOpenChange: (value: boolean) => void;
    encounter: FormattedEncounter | null
}
// This component manages whether to show details in a sheet (mobile) or directly (desktop)
export const TodoDetails = ({ encounter, onOpenChange, open }: TodoDetailsProps) => {

    const isMobile = useIsMobile()

    if (!encounter) {
        return null
    }

    return (
        <div className="w-full">
            {/* For larger screens, show directly in the layout */}
            {!isMobile && encounter && (<div className={cn("w-full flex justify-start h-full")}>
                <TodoDetailsContent encounter={encounter} className="bg-white p-4 w-full rounded-[24px]" />
            </div>)}

            {/* For mobile, use Sheet component */}
            {encounter && isMobile && open && <Sheet open={open} onOpenChange={onOpenChange}>
                <SheetContent title="todo-patient-details" side="right"
                    className="flex flex-col gap-6 overflow-y-auto p-4 sm:p-6 w-full focus:outline-none">
                    <TodoDetailsContent className="w-full" encounter={encounter} />
                </SheetContent>
            </Sheet>}
        </div>
    )
}